import type { FC } from 'react';
import { StackedLinkGroup } from '../StackedLinkGroup';
import { useCustomerServiceLinks } from './useCustomerServiceLinks';

export const StackedCustomerServiceLinks: FC = () => {
    const { data, isLoading } = useCustomerServiceLinks();
    if (isLoading || !data) return null;
    return <StackedLinkGroup {...data} />;
};
